const truncateFilename = (name, maxLen = 30) => {
  if (!name) return "Н/Д";
  if (name.length <= maxLen) return name;
  const dotIdx = name.lastIndexOf(".");
  if (dotIdx <= 0) return name.slice(0, maxLen) + "...";
  const ext = name.slice(dotIdx);
  const available = maxLen - ext.length - 4;
  if (available <= 0) return name.slice(0, maxLen) + "...";
  return name.slice(0, available) + "... " + ext;
};

export default truncateFilename;
